/**
 * Landing query for the global Process tree (Processes tab).
 *
 * Returned flat with `parentId` set from the optional
 * `(:Process)-[:HAS_SUBPROCESS]->(:Process)` edge. The client builds
 * the actual tree by grouping rows on `parentId`. Each row also
 * carries:
 *   - `implementationCount` — distinct `:Line` nodes that
 *     `INSTANTIATE` this process anywhere in the graph.
 *   - `subprocessCount`     — distinct direct `:Process` children.
 *
 * Drained client-side via `drainCypherRows` so we can ingest
 * arbitrarily deep process trees rather than stopping at the proxy's
 * first page — losing a row here would orphan its children
 * client-side because the tree-grouping step looks up the parent by
 * id.
 */
export const PLANT_PROCESS_TREE_CYPHER = `
            MATCH (p:Process)
            OPTIONAL MATCH (parent:Process)-[:HAS_SUBPROCESS]->(p)
            WITH p, parent
            OPTIONAL MATCH (impl:Line)-[:INSTANTIATES]->(p)
            WITH p, parent, count(distinct impl) AS implementationCount
            OPTIONAL MATCH (p)-[:HAS_SUBPROCESS]->(child:Process)
            WITH p, parent, implementationCount, count(distinct child) AS subprocessCount
            RETURN p,
                   parent.id AS parentId,
                   implementationCount,
                   subprocessCount
            ORDER BY p.name
            SKIP toInteger($skip) LIMIT toInteger($pageSize)
          `
